const originalPlay = HTMLMediaElement.prototype.play;

export function overrideAudio(silent: boolean) {
//   console.log("overrideAudio called:", silent);

  if (silent) {
    // console.log("Muting notifications");

    HTMLMediaElement.prototype.play = function () {
    //   console.log("Blocked audio");
      this.muted = true;
      this.volume = 0;
      return Promise.resolve();
    };
  } else {
    // console.log("Restoring notifications");

    HTMLMediaElement.prototype.play = originalPlay;
  }
}